import { api } from './authenticatedApi';

export interface CampaignRepo {
  id: string;
  repositoryId: string;
  repoName: string;
  status: 'pending' | 'running' | 'ok' | 'skipped' | 'failed';
  branch: string | null;
  filesChanged: number;
  patch: string | null;
  message: string | null;
}

export interface Campaign {
  id: string;
  taskType: string;
  issueTitle: string;
  status: string;
  totalRepos: number;
  completedRepos: number;
  okRepos: number;
  createdAt: string;
  repos: CampaignRepo[];
}

export class CampaignService {
  static async create(data: {
    organizationId: string;
    taskType: string;
    issueTitle: string;
    repositoryIds?: string[];
  }) {
    return api.post<Campaign>('/campaigns', data);
  }

  static async get(id: string) {
    return api.get<Campaign>(`/campaigns/${id}`);
  }
}
